import { render, staticRenderFns } from "./ParameterSetting.vue?vue&type=template&id=bff5a3d8"
import script from "./ParameterSetting.vue?vue&type=script&lang=js"
export * from "./ParameterSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff5a3d8')) {
      api.createRecord('bff5a3d8', component.options)
    } else {
      api.reload('bff5a3d8', component.options)
    }
    module.hot.accept("./ParameterSetting.vue?vue&type=template&id=bff5a3d8", function () {
      api.rerender('bff5a3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/ParameterSetting.vue"
export default component.exports